import {Grid, Link, Typography} from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import {Link as RouterLink} from "react-router-dom";
import React from "react";
import {Breadcrumbs as BreadcrumbsCore}  from "@material-ui/core";

export const Breadcrumbs = (props) => {

    const path = props.path;
    
    return (
        <Grid item>
            <BreadcrumbsCore
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
            >
                {path.map((item, i) => {

                    let html = '';
                    if (i < path.length - 1) {
                        return <Link key={i} variant="body1" color="inherit" to={item.url} component={RouterLink}>{item.name}</Link>;
                    } else {
                        return <Typography key={i} variant="body1" color="textPrimary">{item.name}</Typography>;
                    }
                })}

            </BreadcrumbsCore>
        </Grid>);
}